export const API = {
    getCurrentUser: "stores/auth/currentuser",
    getAllModifier: "stores/{storeId}/modifiers",
    getAllModfierSet: "stores/{storeId}/modifiers/set",
    getOneModifierSet: "stores/{storeId}/modifiers/set/{modifierId}",
    getAllPOSCustomer: "stores/{storeId}/customers",
    getAllPosProductList: "stores/{storeId}/products",
    getProductNamesForPos: "stores/{storeId}/products/names",
    getAllPosManualTax: "stores/{storeId}/tax",
    updateorDeleteTax: "stores/{storeId}/tax/{taxId}/",
    checkDuplicateTax: "stores/{storeId}/tax/check",
    getAllCategoryProducts: 'stores/{storeId}/tax/{taxId}/products',
    createTaxCategories: "stores/{storeId}/tax/",
    getOnePosTax: "stores/{storeId}/tax/{id}",
    getPosTaxProducts: "stores/{storeId}/tax/products",
    getAllPosZones: "stores/{storeId}/zone",
    getPosCustomerHistory: "stores/{storeId}/customers/{customerId}/history",
    getAdminCustomerHistory: "stores/{storeId}/users/{customerId}/logs",
    getAllPosModifiers: "stores/{storeId}/modifiers",
    optionExist: "stores/{storeId}/modifiers/{modifierId}/exists",
    modifierSetExist: "stores/{storeId}/modifiers/{modifierSetId}/products/exists",
    deleteModifierOption: "stores/{storeId}/modifiers/{modifierId}",
    updateModifierOption: "stores/{storeId}/modifiers/{modifierId}",
    checkDuplicate: "stores/{storeId}/common/checkduplicates",
    getAllPosCustomerGroup: "stores/{storeId}/customers/group",
    getOnePosCustomerGroup: "stores/{storeId}/customers/group/{id}",
    getAllPosMappingCustomers: "stores/{storeId}/customers/group/{customerGroupId}/customers",
    addCategory: "stores/{storeId}/categories",
    deleteCategory: "stores/{storeId}/categories/{categoryId}/DEFAULT/DEFAULT",
    bulkDeleteCategory: "stores/{storeId}/categories/delete",
    getOnePlugin: "stores/{storeId}/plugins/plugincode",
    updateSortedCategory: "stores/{storeId}/categories/sort",
    getOneCategory: "stores/{storeId}/categories/{id}",
    updateCategory: "stores/{storeId}/categories/{editId}",
    getAllPosCategories: "stores/{storeId}/categories",
    getParentCategory: "stores/{storeId}/categories/parent",
    addProduct: "stores/{storeId}/categories/product",
    getAllPosDiscount: "stores/{storeId}/discounts",
    updateDiscountStatus: "stores/{storeId}/discounts/{id}/status",
    getDiscountBasedUserDetails: "stores/{storeId}/discounts/{discountId}/detail",
    getPosDiscountHistoryLogs: "stores/{storeId}/discounts/{discountId}/history",
    getDiscountTypes: "stores/{storeId}/discounts/types",
    getOneDiscount: "stores/{storeId}/discounts/{id}",
    updatePayXDiscount: "stores/{storeId}/discounts/payxgetfree/{id}",
    bulkDeleteDiscount: "stores/{storeId}/discounts/delete",
    addDiscount: "stores/{storeId}/discounts",
    addPayXDiscount: "stores/{storeId}/discounts/payxgetfree/",
    getCouponDiscount: "stores/{storeId}/discounts",
    getSortCategoryList: "stores/{storeId}/categories/name",
    getAllPosCategoryProducts: "stores/{storeId}/products/name",
    deleteCategoryProduct: "stores/{storeId}/categories/product/{productID}/{id}",
    getAllPosGiftCard: "stores/{storeId}/giftcards",
    getAllPosGiftCardForSellScreen: "stores/{storeId}/giftcards/list",
    getOnePosGiftCard: "stores/{storeId}/giftcards/{giftCardId}",
    getAllPosPurchasedGiftCard: "stores/{storeId}/purchasedgiftcards",
    getOnePosPurchasedGiftCard: "stores/{storeId}/purchasedgiftcards/{giftCardId}",
    getOnePostDuplicateCheck: "stores/{storeId}/common/checkduplicates",
    getPosPostgiftCard: "stores/{storeId}/giftcards",
    getPosIssueCardCustomers: "stores/{storeId}/customers/name",
    getOnePostIssueGiftCard: "stores/{storeId}/giftcards/custom",
    getAllPosZone: "stores/{storeId}/zone",
    getOnePosZoneNames: "stores/{storeId}/zone/{zoneId}",
    getAllPosBrands: "stores/{storeId}/brands",
    getAllBrandsNameForPos: "stores/{storeId}/brands/name",
    getOnePosBrand: "stores/{storeId}/brands/{id}",
    getAllRoles: 'stores/{storeId}/roles', //createRole,getAllRoles
    getAllPosRoleMenuPermission: "stores/{storeId}/roles/permission",
    getOnePosRole: "stores/{storeId}/roles/{id}",
    getAllPosInvitations: "stores/{storeId}/users/invitation",
    createPosRole: "stores/{storeId}/roles",
    deleteBrandProducts: 'stores/{storeId}/brands/products/{id}', //deleteBrandProducts
    getBrand: 'stores/{storeId}/brands/{id}', //getOneBrand,updateBrand
    deleteBrand: 'stores/{storeId}/brands/',
    createBrand: 'stores/{storeId}/brands', //createBrand
    deleteInvitation: 'stores/{storeId}/users/invitation/{invitationId}',//Delete invitation, Resend invitation mail
    PROPERTY_VALUES_BY_CODE: 'properties/valuebycode', //getPropertyByCode
    getOnePosDiscount: "stores/{storeId}/discounts/{discountId}",
    getAllDiscountTypesForPos: "stores/{storeId}/discounts/types",
    getPosPropertyCode: "properties/code",
    updateDiscount: "stores/{storeId}/discounts/automatic/{discountId}",
    saveDiscount: "stores/{storeId}/discounts/automatic",
    checkExistDiscountName: "stores/{storeId}/discounts/automatic/existence",
    getFreeProductsData: "stores/{storeId}/products/variant/name",
    deleteProduct: "stores/{storeId}/products/catelog/{id}",
    getAllCategoriesNameForPos: 'stores/{storeId}/categories/name',
    getPosStoreLocationsName: 'stores/{storeId}/locations/name',
    bulkDeleteProduct: "stores/{storeId}/products/catelog/delete",
    getStoreLocation: "stores/{storeId}/locations/name",
    getLocationList: "stores/{storeId}/locations",
    checkLocationMapping: "stores/{storeId}/locations/{data}/usage",
    deleteLocation: 'stores/{storeId}/locations/{data}',
    getOneLocation: 'stores/{storeId}/locations/{id}',
    addLocation: 'stores/{storeId}/locations',
    updateLocation: 'stores/{storeId}/locations/{id}',
    getOnePosProductDetails: "stores/{storeId}/products/{id}",
    getVariantCombination: "stores/{storeId}/products/catelog/variantcombination",
    getAllPOSCustomerName: "stores/{storeId}/customers/name",
    getPosOptionList: "stores/{storeId}/option",
    getOnePosOptionList: "stores/{storeId}/option/{selectedId}",
    getOneDeletePosOptionList: "stores/{storeId}/optionsvariants/{deleteId}",
    getOnePostOptionData: "stores/{storeId}/optionsvariants",
    getOneUpdateOptionData: "stores/{storeId}/optionsvariants/{updateId}",
    getOneSortOptionData: "stores/{storeId}/optionsvariants/option/{updateId}/optionvalues/sort",
    getAllSortOptionData: "stores/{storeId}/optionsvariants/option/sort",
    updatePosRole: "stores/{storeId}/roles/{id}",
    deletePosRole: "stores/{storeId}/roles/{id}",
    getDefaultPosCustomerRoles: "stores/{storeId}/roles/customer",
    getPosRoleName: "stores/{storeId}/roles/code",
    fetchPosStoreDetails: 'stores/{storeId}/settings',
    addStoreDetails: 'stores/{storeId}/settings',
    updateStoreDetails: 'stores/{storeId}/settings',
    getPosUnits: 'stores/{storeId}/setting/units',
    getOneBuyXgetYDiscount: "stores/{storeId}/discounts/buyxgety/{discountId}",
    saveBuyXgetY: "stores/{storeId}/discounts/buyxgety/",
    updateBuyXgetY: "stores/{storeId}/discounts/buyxgety/{discountId}",
    checkExistBuyXgetYDiscountName: "stores/{storeId}/discounts/buyxgety/existence",
    getPushNotification: 'stores/{storeId}/pushNotification',
    updatePushNotification: 'stores/{storeId}/pushNotification/{id}',
    updatePoints: "stores/{storeId}/points/customer/{customerId}/balance",
    getTipDetails: "stores/{storeId}/tips",
    getEmailNotification: 'mail/template',
    updateEmailNotification: 'mail/template/customizeTemplate/{id}',
    getAllEmailNotification: 'stores/{storeId}/notification/email',
    getNotificationCustomer: 'stores/{storeId}/notification/email/customerdetails',
    sendNotification: 'stores/{storeId}/notification/email/sendnotification',
    getDisplayData: "stores/{storeId}/displaySetting",
    getPreferenceValues: "stores/{storeId}/preference",
    getOnePosProductForSellScreen: "stores/{storeId}/products/{productId}/details",
    getOnePosProductForSellScreenBySku: "stores/{storeId}/products/sku/{skuId}",
    getOnePosProductDiscount: "stores/{storeId}/products/{productId}/variant/{variantId}/discounts",
    getAuthorizedCartProduct: "stores/{storeId}/cart/{customerId}",
    paymentValues: "stores/{storeId}/paymentSetting",
    getAllProperties: "properties/getallproperties",
    logoutUser: "admin/logout",
    saveVendor: "stores/{storeId}/vendor",
    updateVendorDetails: "stores/{storeId}/vendor/{vendorId}",
    getAllPosVendor: "stores/{storeId}/vendor",
    findAllVendorDetails: "stores/{storeId}/vendor/all",
    clockIn: "timecard/attendence/create",
    getAllTimeCardDetails: "timecard/attendence/list/{storeId}",
    deleteAttendence: "timecard/attendence/delete/{id}",
    getAllPurchaseOrder: "stores/{storeId}/purchaseOrder",
    findAllShippingServices: "stores/{storeId}/purchaseOrder/shipping",
    deletePurchaseOrder: "stores/{storeId}/purchaseOrder/{purchaseOrderId}",
    getAllPosProductVariant: "stores/{storeId}/variant/name",
    getOnePurchaseOrder: "stores/{storeId}/purchaseOrder/{id}",
    updatePurchaseOrder: "stores/{storeId}/purchaseOrder/ordered/{purchaseOrderId}",
    cancelPurchaseOrder: "stores/{storeId}/purchaseOrder/cancel/{id}",
    getOneVendorDetails: "stores/{storeId}/vendor/{id}",
    getAllOrdersList: "stores/{storeId}/orders/list",
    getAllPosOrdersList: "stores/{storeId}/orders/pos/list",
    updateVendorStatus: "stores/{storeId}/vendor/{id}/status",

    getAllInventoryLocation: "stores/{storeId}/locations/users",
    deleteOrder: "stores/{storeId}/orders/remove",
    savedFilter: "stores/{storeId}/savedFilter",
    delteFilter: "stores/{storeId}/savedFilter/{filterId}",
    properties: "properties/code",
    clockOut: "timecard/attendence/create",
    sendEmail: "stores/{storeId}/users/invitation",
    checkEmail: "stores/{storeId}/users/invitation/check",
    sendLocation: "stores/{storeId}/locations/v3",

    getAllBillForPO: "stores/{storeId}/bill",
    deleteBill: "stores/{storeId}/bill/{billId}",
    cancelBill: "stores/{storeId}/bill/cancel/{billId}",
    updateBillDetails: "stores/{storeId}/bill/{billId}",
    updateOverdueBills: "stores/{storeId}/bill/overdue",
    getAllPoPaymentComments: "stores/{storeId}/popayment/comment/{id}",
    getAllVendorCreditComment: "stores/{storeId}/pocredit/comment/{id}",
    getMeasurement: "stores/{storeId}/shipping/property/MEASUREMENT/fulfillment",
    updateProductDetails: "stores/{storeId}/products/productDataFormation/{productId}",
    //commentHistory
    getAllBillComments: "stores/{storeId}/bill/comment/{id}",
    createBillComment: "stores/{storeId}/bill/comment",
    createPOComment: "stores/{storeId}/purchaseOrder/comment",
    createPaymentComment: "stores/{storeId}/popayment/comment",
    createVendorCreditComment: "stores/{storeId}/pocredit/comment",
    getAllVendorCreditComments: "stores/{storeId}/pocredit/comment/{id}",

    //cds
    createCustomerDisplayScreen: "stores/{storeId}/display",

    // Transfer Order
    getTransferOrderDetails: "stores/{storeId}/transfer",
    deleteTransferOrder: "stores/{storeId}/transfer/{transferOrderId}",
    getOneTransferOrder: "stores/{storeId}/transfer/{id}",
    getStock: "stores/{storeId}/transfer/stock",
    receivedQuantity: "stores/{storeId}/transfer/{id}/mapping/{productMappingId}",
    getPaymentList: "stores/{storeId}/popayment",
    getOneTimeCard: "timecard/attendence/getOne/{timeCardId}",
    updateTimeCard: "timecard/attendence/update/{id}",
    bulkDeleteTimeCard: "timecard/attendence/bulkDelete",
    getAllStaffs: "stores/{storeId}/posStaff/{clientId}/{isActive}",
    // Orders
    singleOrderDetails: 'stores/{storeId}/orders/{orderId}',
    orderDiscount: 'stores/{storeId}/discounts/orders',
    orderNotes: 'stores/{storeId}/ordernotes',
    productVariant: "stores/{storeId}/products/{productId}/variants",
    productModifiers: "stores/{storeId}/products/{productId}/{variantId}/modifiers",
    orderRefund: 'stores/{storeId}/payment/refund',
    orderLoyalty: 'stores/{storeId}/points/customer/{customerId}/balance',
    orderShipping: 'stores/{storeId}/shipping/orders/{orderId}',
    updateOrderShipping: 'stores/{storeId}/orders/shipping',
    returnProduct: 'stores/{storeId}/orders/{orderId}/returnRequest/product/{productId}',
    returnOrder: 'stores/{storeId}/orders/{orderId}/returnRequest?returnAllProducts=true',
    restoreInventoryLocation: 'stores/{storeId}/products/restoreInventory',
    updateReturnProductStatus: "stores/{storeId}/orders/{orderId}/returnRequest/{returnId}",
    updateReturnProduct: 'stores/{storeId}/orders/{orderId}/stock/restore',
    restoreOrder: 'stores/{storeId}/orders/{orderId}/restore',
    orderInvoice: 'invoice/order',
    vendorCredit: "stores/{storeId}/pocredit",
    updateCustomerStatus: "stores/{storeId}/customers/{customerId}/status",
    sendCustomerEmail: "customer/{customerId}/mail/verification",
    defaultRoles: "stores/{storeId}/roles/default/roles",
    getAllReceiveList: 'stores/{storeId}/receive',
    getOnePurchaseOrderReceive: 'stores/{storeId}/purchaseOrder/order/{orderId}',
    getOnePurchaseOrderReceiveDetails: 'stores/{storeId}/receive/{vendorId}',
    updateTransitOrder: 'stores/{storeId}/receive/transit/{vendorId}',
    cartProductId: "stores/{storeId}/cart/products/{cartProductId}",
    deleteCart: "stores/{storeId}/cart/delete",
    getAllEligibleDiscount: "stores/{storeId}/discounts/orders",
    getOneCouponRestrictionDetails: "stores/{storeId}/discounts/restriction/{restrictionId}",
    printMembershipCard: "stores/{storeId}/customers/{customerId}/printMembership",
    getAllBillForVendorCredits: "stores/{storeId}/pocredit/all/",
    getAllGiftCardForSellscreen: "stores/{storeId}/giftcards/list",
    loyaltyPointsLog: "stores/{storeId}/orders/{orderId}/loyalty/pointsLog",
    getRefundDetails: "stores/{storeId}/refund/{id}",

    // Staff
    staffList: 'stores/{storeId}/posStaff/{roleId}/{isActive}',
    addStaff: 'stores/{storeId}/posStaff',
    staffStatus: 'stores/{storeId}/posStaff/{staffId}/status',
    staffDetails: 'stores/{storeId}/posStaff/{staffId}',
    updateStaff: 'stores/{storeId}/posStaff/update/{staffId}',
    deleteStaff: 'stores/{storeId}/staff/{staffId}/status',
    emailVerify: 'admin/mail/check',
    staffTarget: 'stores/{storeId}/posStaffTarget/{staffId}',
    getActivityLog: "stores/{storeId}/staff/{userId}/history",
    getDeviceHistory: "stores/{storeId}/staff/{userId}/history/device",
    getCustomerHistory: 'stores/{storeId}/customers/{customerId}/history',
    geAllTotalHours: 'timecard/attendence/{storeId}',
    getOneStaffDetails: 'timecard/attendence/getOneStaff/{staffId}',
    sendMailInvoice: "stores/{storeId}/invoice",
    checkout: "stores/{storeId}/checkout",
    productBulkEdit: "stores/{storeId}/products/bulkedit",
    copyorupload: "common/copyorupload",
    optimizeImage: "stores/{storeId}/zenimages/message",
    activityHistory: 'stores/{storeId}/vendor/{vendorId}/activities',
    PurchaseGiftReport: 'stores/{storeId}/pos/report/giftCard/purchased',
    PaymentReport: 'stores/{storeId}/pos/report/payment',
    RevenueReport: 'stores/{storeId}/pos/report/revenue',
    RegisterClosureReport: 'stores/{storeId}/pos/report/RegisterClosure',
    StoreSetupReport: 'stores/{storeId}/pos/report/storeSetup',
    RevenueAnayticsReport: 'stores/{storeId}/pos/report/dashboard/revenueAnalytics',
    DashboardSummary: 'stores/{storeId}/dashboard',
    DashboardReport: 'stores/{storeId}/report',
    orderReport: 'stores/{storeId}/pos/report/order',
    staffReport: 'stores/{storeId}/pos/report/staff',
    customerReport: 'stores/{storeId}/pos/report/customer',
    //inventory
    getProductSettings: 'stores/{storeId}/products/settings',
    getProductCount: 'stores/{storeId}/products/count',
    getAllInventoryProducts: 'stores/{storeId}/products/inventory',
    getAllPreOrderQty: 'stores/{storeId}/preorder/quantity',
    addQuantity: 'stores/{storeId}/inventory/add',
    setQuantity: 'stores/{storeId}/inventory/set',

    //sellscreen payment
    placeOrders: '{storeId}/posorders/placeorder',
    returnOrderForSellScreen: 'stores/{storeId}/orders/{orderId}/return',
    //add/editManual discount
    eligibleCustomer: 'stores/{storeId}/customers/',
    getOnePurchasedGiftCardForPayment: 'stores/{storeId}/purchasedgiftcards/details/{coupon}',
    offerReport: "stores/{storeId}/pos/report/",
    receiptSettings: "stores/{storeId}/receiptSettings",
    updateReceiptSettings: "stores/{storeId}/receiptSettings",
    //comments
    purchaseOrderComment: "stores/{storeId}/purchaseOrder/{vendorId}/comment",
    billComment: "stores/{storeId}/bill/{vendorId}/comment",
    poPaymentComment: "stores/{storeId}/popayment/{vendorId}/comment",
    purchaseReceiveComment: "stores/{storeId}/receive/{vendorId}/comment",
    vendorCreditComment: "stores/{storeId}/pocredit/comment/{vendorCreditId}",
    getUserDetails: "stores/{storeId}/users/{userId}/notification",
    deactivateAccount: "stores/auth/deactivate",
    getOnePluginDetails: "stores/{storeId}/plugins/code",
    checkPasswordForAdminProfile: "admin/check/password",
    changeEmail: "admin/credential",
    uploadLogoUrl: "stores/{storeId}/users/uploadLogoUrl",
    checkCustomerPhoneNumber: "stores/{storeId}/customers/check/by-phone",
    userActivities: "stores/{storeId}/posStaff/{userId}/activities",
    insertBulkProductIntoCart: "stores/{storeId}/cart/upload/{customerId}",
    // Return Reasons
    returnReasons: "stores/{storeId}/return-reason",
    deleteReturnReason: "stores/{storeId}/return-reason/{id}"
}
